"use client";

import { c as _c } from "react/compiler-runtime";
import { toggleCommentReaction } from "@/actions/comment";
import { CommentActionArea, CommentContainer, CommentContentArea, CommentHeader, CommentInfoHeader, CommentProfileImageArea, CommentText } from "@/components/fancy/comment";
import CenteredArea from "@/components/layout/centered-area";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { queryClient } from "@/providers/react-query";
import { TComment, TContentType } from "@/types/types";
import { formatUserFullName } from "@/utils/formatters";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { formatDistanceToNowStrict } from "date-fns";
import { ThumbsDown, ThumbsUp } from "flowbite-react-icons/outline";
import { ThumbsDown as ThumbsDownFilled, ThumbsUp as ThumbsUpFilled } from "flowbite-react-icons/solid";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { DotSymbol } from "../fancy/html-symbol";
import CommentMenu from "./comment-menu";
import ReplyForm from "./reply-form";
import ReplyList from "./reply-list";
interface CommentItemProps {
  contentType: TContentType;
  contentId: string;
  comment: TComment;
}
export default function CommentItem(t0) {
  const $ = _c(88);
  const {
    contentType,
    contentId,
    comment
  } = t0;
  const [isReplyFormVisible, setIsReplyFormVisible] = useState(false);
  const [isRepliesViewVisible, setIsRepliesViewVisible] = useState(false);
  const {
    userId
  } = useAuth();
  let t1;
  if ($[0] !== comment.id || $[1] !== contentId || $[2] !== contentType) {
    t1 = async function handleToggleLike() {
      const {
        error
      } = await tryCatch(toggleCommentReaction(comment.id, "LIKE"));
      if (error) {
        toast.error(error.message);
        return;
      }
      queryClient.invalidateQueries({
        queryKey: [`get-comments:${contentType}:${contentId}`]
      });
    };
    $[0] = comment.id;
    $[1] = contentId;
    $[2] = contentType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleToggleLike = t1;
  let t2;
  if ($[4] !== comment.id || $[5] !== contentId || $[6] !== contentType) {
    t2 = async function handleToggleDislike() {
      const {
        error: error_0
      } = await tryCatch(toggleCommentReaction(comment.id, "DISLIKE"));
      if (error_0) {
        toast.error(error_0.message);
        return;
      }
      queryClient.invalidateQueries({
        queryKey: [`get-comments:${contentType}:${contentId}`]
      });
    };
    $[4] = comment.id;
    $[5] = contentId;
    $[6] = contentType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleToggleDislike = t2;
  let t3;
  if ($[8] !== comment.user.profile) {
    t3 = comment.user.profile?.imageUrl && <AvatarImage src={comment.user.profile.imageUrl} alt={`Profile picture of ${formatUserFullName(comment.user.profile.firstName, comment.user.profile.lastName)}`} />;
    $[8] = comment.user.profile;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = comment.user.profile?.firstName?.[0];
  const t5 = comment.user.profile?.lastName?.[0];
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = formatUserFullName(t4, t5);
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <AvatarFallback>{t6}</AvatarFallback>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <CommentProfileImageArea><Avatar>{t3}{t7}</Avatar></CommentProfileImageArea>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = comment.user.profile?.firstName;
  const t10 = comment.user.profile?.lastName;
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = formatUserFullName(t9, t10);
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <p className="font-semibold">{t11}</p>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <DotSymbol />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== comment.createdAt) {
    t14 = formatDistanceToNowStrict(comment.createdAt, {
      addSuffix: true
    });
    $[24] = comment.createdAt;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14) {
    t15 = <p>{t14}</p>;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t15) {
    t16 = <CommentInfoHeader>{t12}{t13}{t15}</CommentInfoHeader>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== comment || $[32] !== contentId || $[33] !== contentType || $[34] !== userId) {
    t17 = comment.userId === userId && <CommentMenu contentType={contentType} contentId={contentId} comment={comment} />;
    $[31] = comment;
    $[32] = contentId;
    $[33] = contentType;
    $[34] = userId;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16 || $[37] !== t17) {
    t18 = <CommentHeader>{t16}{t17}</CommentHeader>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== comment.content) {
    t19 = <CommentText>{comment.content}</CommentText>;
    $[39] = comment.content;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== comment.userReaction) {
    t20 = comment.userReaction === "LIKE" ? <ThumbsUpFilled size={20} /> : <ThumbsUp size={20} strokeWidth={1.5} />;
    $[41] = comment.userReaction;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== handleToggleLike || $[44] !== t20) {
    t21 = <Button variant="ghost" size="icon" className="flex h-auto w-auto items-center gap-2 p-1" onClick={handleToggleLike}>{t20}</Button>;
    $[43] = handleToggleLike;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== comment.likeCount) {
    t22 = comment.likeCount > 0 && <span className="text-xs">{comment.likeCount}</span>;
    $[46] = comment.likeCount;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t21 || $[49] !== t22) {
    t23 = <div className="flex items-center">{t21}{t22}</div>;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== comment.userReaction) {
    t24 = comment.userReaction === "DISLIKE" ? <ThumbsDownFilled size={20} /> : <ThumbsDown size={20} strokeWidth={1.5} />;
    $[51] = comment.userReaction;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== handleToggleDislike || $[54] !== t24) {
    t25 = <Button variant="ghost" size="icon" className="flex h-auto w-auto items-center gap-2 p-1" onClick={handleToggleDislike}>{t24}</Button>;
    $[53] = handleToggleDislike;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== comment.dislikeCount) {
    t26 = comment.dislikeCount > 0 && <span className="text-xs">{comment.dislikeCount}</span>;
    $[56] = comment.dislikeCount;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t25 || $[59] !== t26) {
    t27 = <div className="flex items-center">{t25}{t26}</div>;
    $[58] = t25;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Button variant="ghost" size="sm" onClick={() => setIsReplyFormVisible(true)} className="hover:no-underline">Reply</Button>;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t23 || $[63] !== t27) {
    t29 = <div className="flex items-center gap-2">{t23}{t27}{t28}</div>;
    $[62] = t23;
    $[63] = t27;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== comment.id || $[66] !== contentId || $[67] !== contentType || $[68] !== isReplyFormVisible) {
    t30 = isReplyFormVisible && <div className="py-2"><ReplyForm contentType={contentType} contentId={contentId} parentCommentId={comment.id} hideReplyForm={() => setIsReplyFormVisible(false)} /></div>;
    $[65] = comment.id;
    $[66] = contentId;
    $[67] = contentType;
    $[68] = isReplyFormVisible;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== comment._count.replies || $[71] !== isRepliesViewVisible) {
    t31 = comment._count.replies > 0 && <Button variant="link" onClick={() => setIsRepliesViewVisible(!isRepliesViewVisible)} className="hover:no-underline">{isRepliesViewVisible ? <ChevronUp size={16} className="mr-2" /> : <ChevronDown size={16} className="mr-2" />}<span>{isRepliesViewVisible ? "Hide" : "View"} {comment._count.replies}{" "}{comment._count.replies > 1 ? "replies" : "reply"}</span></Button>;
    $[70] = comment._count.replies;
    $[71] = isRepliesViewVisible;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== comment.id || $[74] !== isRepliesViewVisible) {
    t32 = isRepliesViewVisible && <CenteredArea className="h-auto"><ReplyList parentCommentId={comment.id} /></CenteredArea>;
    $[73] = comment.id;
    $[74] = isRepliesViewVisible;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  let t33;
  if ($[76] !== t29 || $[77] !== t30 || $[78] !== t31 || $[79] !== t32) {
    t33 = <CommentActionArea className="mt-1">{t29}{t30}{t31}{t32}</CommentActionArea>;
    $[76] = t29;
    $[77] = t30;
    $[78] = t31;
    $[79] = t32;
    $[80] = t33;
  } else {
    t33 = $[80];
  }
  let t34;
  if ($[81] !== t18 || $[82] !== t19 || $[83] !== t33) {
    t34 = <CommentContentArea>{t18}{t19}{t33}</CommentContentArea>;
    $[81] = t18;
    $[82] = t19;
    $[83] = t33;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  let t35;
  if ($[85] !== t34 || $[86] !== t8) {
    t35 = <CommentContainer>{t8}{t34}</CommentContainer>;
    $[85] = t34;
    $[86] = t8;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  return t35;
}